// URLs
export const apiUrl = process.env.NEXT_PUBLIC_API_URL || "https://www.admissiontaker.site";
export const baseUrl = process.env.NEXT_PUBLIC_BASE_URL || "http://localhost:3000";
export const apiPrefix = process.env.NEXT_PUBLIC_API_PREFIX || "api";

// App Meta
export const googleTrackingID = process.env.NEXT_PUBLIC_GOOGLE_TRACKING_ID;
export const appName = process.env.NEXT_PUBLIC_APP_NAME;
export const appWebsite = process.env.NEXT_PUBLIC_APP_WEBSITE;
export const devName = process.env.NEXT_PUBLIC_DEV_NAME;
export const devWebsite = process.env.NEXT_PUBLIC_DEV_WEBSITE;
export const classPrefix = process.env.NEXT_PUBLIC_CLASS_PREFIX;

// Google Maps
export const googleMapApiKey = process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY;
export const googleMapDefaultLocation = {
  lat: parseFloat(process.env.NEXT_PUBLIC_GOOGLE_MAP_LAT || "23.7808875"),
  lng: parseFloat(process.env.NEXT_PUBLIC_GOOGLE_MAP_LNG || "90.2792371"),
};
export const googleMapCountryList = (process.env.NEXT_PUBLIC_GOOGLE_MAP_COUNTRIES || "bd").split(",");
export const googleMapDefaultZoom = parseInt(process.env.NEXT_PUBLIC_GOOGLE_MAP_ZOOM || "14", 10);

// Timezone & Socials
export const timezone = process.env.NEXT_PUBLIC_TIMEZONE || "Asia/Dhaka";
export const fbID = process.env.NEXT_PUBLIC_FB_ID;
export const fbPageID = process.env.NEXT_PUBLIC_FB_PAGE_ID;

// SEO
export const siteTitle = process.env.NEXT_PUBLIC_SITE_TITLE || "Website Title";
export const siteTagLine = process.env.NEXT_PUBLIC_SITE_TAGLINE || "Website Tag Line";
export const metaDesc =
  process.env.NEXT_PUBLIC_META_DESC ||
  "Lorem Ipsum is simply dummy text of the printing and typesetting industry.";
export const metaKeywords = process.env.NEXT_PUBLIC_META_KEYWORDS || "education, admission, focus academy";
